import { render, staticRenderFns } from "./FilePdfIcon.vue?vue&type=template&id=a527f12e"
import script from "./FilePdfIcon.vue?vue&type=script&lang=js"
export * from "./FilePdfIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports